import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseApiService } from './base-api.service';

/**
 * Health API Service
 */
@Injectable({
    providedIn: 'root'
})
export class HealthService extends BaseApiService {

    /**
     * Get health status
     */
    getHealthStatus(): Observable<any> {
        return this.get<any>('/health/status')
            .pipe(map(response => response.data!));
    }
}
